import { Icon } from "@iconify/react";


export default function Icons({ icons }) {
  return (
    <section className="container ce_icons">
      <div className="row text-center">
        {icons.map((item, index) => (
          <div key={index} className="col-6 col-md-3 mb-4">
            <Icon icon={item.icon} width="48" height="48" className="mb-2" />
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
